import { useState } from "react";
import { format_number } from "../../../utilities/ext-function";
import SimpleBar from "simplebar-react";

const ITEMS_PER_PAGE = 4; // Jumlah data per halaman

export default function ChatbotPanelTable({ dataChatbot }) {
  const [currentPage, setCurrentPage] = useState(1);

  // Hitung jumlah halaman
  const totalPages = Math.ceil(dataChatbot.length / ITEMS_PER_PAGE);

  // Ambil data yang sesuai dengan halaman saat ini
  const paginatedData = dataChatbot.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  return (
    <div
      className="d-flex justify-space-between"
      style={{
        minHeight: "180px",
        flexDirection: "column",
      }}
    >
      <SimpleBar style={{ minHeight: "180px", overflowY: "auto" }}>
        <table className="table table-striped">
          <tbody>
            {paginatedData.map((item, index) => (
              <tr key={index}>
                <td className="pt-2 pb-2 p-2">{item.name}</td>
                <td align="right" className="pt-2 pb-2 p-2">
                  {format_number(item.message_count)} Messages
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </SimpleBar>

      {/* Pagination tetap di bawah */}
      {dataChatbot.length > 4 && (
        <div className="d-flex justify-content-center gap-2 mt-auto">
          <button
            className="btn btn-sm"
            style={{ backgroundColor: "#293042", color: "#fff" }}
            onClick={() => setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Prev
          </button>
          <button
            className="btn btn-sm"
            style={{ backgroundColor: "#293042", color: "#fff" }}
            onClick={() => setCurrentPage(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}
